var map = {
	"./interfaces/audio-video-state.ts": "1wkv",
	"./interfaces/call-session.ts": "lV1E",
	"./interfaces/channel.ts": "F+3g",
	"./interfaces/index.ts": "9CmM",
	"./interfaces/person-connection.ts": "/LPr",
	"./interfaces/stats.ts": "3Mw1",
	"./interfaces/stream.ts": "Z0l7",
	"./lib/doxyme-opentok-mos.ts": "IZqc",
	"./lib/video-freeze-analyzer.ts": "LEEc",
	"./lib/webrtc-stats-analyzer.ts": "gfRa",
	"./providers.common.js": "OL3I",
	"./services/active-stream-service.ts": "lp05",
	"./services/auto-media-disabler/auto-media-disabler.ts": "sdWX",
	"./services/auto-media-disabler/index.ts": "oa8B",
	"./services/closed-captions-service.ts": "Iasv",
	"./services/downgrade-call-state-service.ts": "yLQ6",
	"./services/enable-camera-error-handler.ts": "T+uK",
	"./services/media-stream-track-helper.ts": "pYgY",
	"./services/video-freeze-detector.ts": "wmbV",
	"./services/video-provider-factory.ts": "JC1L",
	"./services/video-provider-helper.ts": "l9D+",
	"./services/video-provider-resolver.ts": "FSZf",
	"./services/webrtc-connection-stats-collector.ts": "Iyv2",
	"./video-provider-events.ts": "ybDG"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "KXmR";